@if (!isGuestEditModeEnable) {

  <!-- Named guests + anonymous result — all in one grid row -->
  @if (!anonymousEditMode) {
    <div class="row cbw-event-additional-guest-layout">
      <!-- Named guest cards (named_only / both) -->
      @if (showNamedSection) {
        @for (additionalGuest of additionalGuests; track additionalGuest; let index = $index) {
          <div class="col-12 col-md-6 mt-3 cbw-event-additional-guest-cards">
            <div class="additional-guest-card cbw-guest-card d-flex align-items-center justify-content-between gap-2 w-100 h-100">
              <div class="cbw-guest-badge">
                <calio-mat-icon iconType="person_filled" height="28px" width="28px" fill="var(--primary-color)" />
              </div>
              <div class="d-flex flex-column justify-content-start additional-guest-info">
                <div class="title cbw-guest-card-title">{{ additionalGuest.prename }} {{ additionalGuest.lastname }}</div>
                @if (additionalGuest?.email) {
                  <div class="sub-title cbw-guest-card-subtitle">{{ additionalGuest?.email }}</div>
                }
                @if (additionalGuest?.phone) {
                  <div class="sub-title cbw-guest-card-subtitle">{{ additionalGuest?.phone }}</div>
                }
              </div>
              @if (!disableAdditionalParticipantsEditing) {
                <div class="d-flex align-items-center justify-content-center gap-2">
                  <calio-mat-icon iconType="edit" height="22px" width="22px" fill="#7A8699" (clickEvent)="editAdditionalGuests(additionalGuest, index)" customClass="cursor-pointer cbw-guest-action" />
                  <calio-mat-icon iconType="close" height="22px" width="22px" fill="#7A8699" (clickEvent)="removeAdditionalGuest(index)" customClass="cursor-pointer cbw-guest-action" />
                </div>
              }
            </div>
          </div>
        }
      }

      <!-- Anonymous guest result card — sits beside the named guest cards -->
      @if (showAnonymousSection && anonymousGuestCount > 0) {
        <div class="col-12 col-md-6 mt-3 cbw-event-additional-guest-cards">
          <div class="additional-guest-card cbw-anonymous-result d-flex align-items-center justify-content-between gap-2 w-100 h-100">
            <div class="cbw-guest-badge">
              <calio-mat-icon iconType="group" height="28px" width="28px" fill="var(--primary-color)" />
            </div>
            <div class="d-flex flex-column justify-content-start additional-guest-info">
              <div class="title cbw-guest-card-title">
                @if (anonymousGuestCount === 1) {
                  {{ 'common.additionalGuestCartLabel' | translate: { number: anonymousGuestCount } }}
                } @else {
                  {{ 'common.additionalGuestsCartLabel' | translate: { number: anonymousGuestCount } }}
                }
              </div>
              <div class="sub-title cbw-guest-card-subtitle">{{ 'common.guestCountHelper' | translate }}</div>
            </div>
            @if (!disableAdditionalParticipantsEditing) {
              <div class="d-flex align-items-center justify-content-center gap-2">
                <calio-mat-icon iconType="edit" height="22px" width="22px" fill="#7A8699" (clickEvent)="enterAnonymousEdit()" customClass="cursor-pointer cbw-guest-action" />
                <calio-mat-icon iconType="close" height="22px" width="22px" fill="#7A8699" (clickEvent)="removeAnonymousCount()" customClass="cursor-pointer cbw-guest-action" />
              </div>
            }
          </div>
        </div>
      }

      <!-- Add participants button (named modes only) -->
      @if (showNamedSection && showAddAdditionalGuestButton) {
        <div
          class="col-12 col-md-6 mt-3 cbw-event-additional-guest-cards"
          (click)="addNewAdditionalGuest()"
          (keydown.enter)="addNewAdditionalGuest()"
          (keydown.space)="addNewAdditionalGuest(); $event.preventDefault()"
          tabindex="0"
          role="button"
          [attr.aria-label]="('common.addAdditionalGuest' | translate) + ' — ' + ('common.addParticipantHint' | translate)">
          <div class="additional-guest-card additional-guest cbw-add-participant-tile d-flex align-items-center gap-2 w-100 h-100">
            <div class="cbw-guest-badge">
              <calio-mat-icon iconType="person_add" height="28px" width="28px" fill="var(--primary-color)" />
            </div>
            <div class="d-flex flex-column justify-content-start additional-guest-info">
              <div class="title cbw-guest-card-title">{{ 'common.addAdditionalGuest' | translate }}</div>
              <div class="sub-title cbw-guest-card-subtitle">{{ 'common.addParticipantHint' | translate }}</div>
            </div>
            <calio-mat-icon iconType="add" height="22px" width="22px" fill="#7A8699" customClass="cbw-add-affordance" />
          </div>
        </div>
      }

      <!-- Add guest count tile — shown whenever the anonymous option is open
           (anonymous_only AND both), side by side with "Add participants" -->
      @if (showAnonymousSection && anonymousGuestCount === 0 && getMaxAnonymousAllowed() > 0 && !disableAdditionalParticipantsEditing) {
        <div
          class="col-12 col-md-6 mt-3 cbw-event-additional-guest-cards"
          (click)="enterAnonymousEdit()"
          (keydown.enter)="enterAnonymousEdit()"
          (keydown.space)="enterAnonymousEdit(); $event.preventDefault()"
          tabindex="0"
          role="button"
          [attr.aria-label]="('common.addGuestCount' | translate) + ' — ' + ('common.addGuestCountHint' | translate)">
          <div class="additional-guest-card additional-guest cbw-add-guest-count-tile d-flex align-items-center gap-2 w-100 h-100">
            <div class="cbw-guest-badge">
              <calio-mat-icon iconType="group" height="28px" width="28px" fill="var(--primary-color)" />
            </div>
            <div class="d-flex flex-column justify-content-start additional-guest-info">
              <div class="title cbw-guest-card-title">{{ 'common.addGuestCount' | translate }}</div>
              <div class="sub-title cbw-guest-card-subtitle">{{ 'common.addGuestCountHint' | translate }}</div>
            </div>
            <calio-mat-icon iconType="add" height="22px" width="22px" fill="#7A8699" customClass="cbw-add-affordance" />
          </div>
        </div>
      }

    </div>

  }

  <!-- Anonymous stepper (full-width, hides named section while open) -->
  @if (showAnonymousSection && anonymousEditMode) {
    <div class="row cb-event-additional-guest-layout">
      <div class="col-12 col-md-6 mt-3 cbw-event-additional-guest-cards">
        <div class="cbw-anonymous-stepper-card">
          <calio-mat-icon iconType="close" height="18px" width="18px" fill="#909AAF" (clickEvent)="cancelAnonymousEdit()" customClass="cursor-pointer cbw-anonymous-close-btn" />
          <div class="cbw-stepper-zones">
            <div class="cbw-stepper-info">
              <div class="cbw-guest-badge">
                <calio-mat-icon iconType="group" height="28px" width="28px" fill="var(--primary-color)" />
              </div>
              <div class="cbw-stepper-info-text">
                <label class="cbw-anonymous-stepper-title" id="label_anonymousGuestCount" for="anonymousGuestCount">
                  {{ 'common.anonymousGuestCount' | translate }}
                </label>
                <div class="cbw-anonymous-help" id="anonymousGuestCountHelp">
                  {{ 'common.guestCountEditHelper' | translate }}
                </div>
              </div>
            </div>
            <div class="cbw-stepper-qty">
              <div class="cbw-anonymous-stepper" role="group" aria-labelledby="label_anonymousGuestCount">
              <button
                type="button"
                class="cbw-anonymous-stepper-btn"
                aria-label="{{ 'common.decrease' | translate }}"
                [disabled]="disableAdditionalParticipantsEditing || tempCountSafe <= 0"
                (click)="stepAnonymousCount(-1)">
                −
              </button>
              <input
                id="anonymousGuestCount"
                name="anonymousGuestCount"
                type="number"
                min="0"
                [max]="getMaxAnonymousAllowed()"
                step="1"
                class="cbw-anonymous-stepper-input"
                [(ngModel)]="tempAnonymousCount"
                (ngModelChange)="onTempAnonymousChange($event)"
                (blur)="onTempAnonymousBlur($event)"
                [disabled]="disableAdditionalParticipantsEditing"
                aria-describedby="anonymousGuestCountHelp"
              />
              <button
                type="button"
                class="cbw-anonymous-stepper-btn cbw-anonymous-stepper-btn--plus"
                aria-label="{{ 'common.increase' | translate }}"
                [disabled]="disableAdditionalParticipantsEditing || tempCountSafe >= getMaxAnonymousAllowed()"
                (click)="stepAnonymousCount(1)">
                +
              </button>
              </div>
              @if (tempCountSafe > getMaxAnonymousAllowed()) {
                <div class="cbw-anonymous-error" role="alert">
                  {{ (getMaxAnonymousAllowed() === 1 ? 'common.guestCountMaxWarningOne' : 'common.guestCountMaxWarning') | translate: { max: getMaxAnonymousAllowed() } }}
                </div>
              }
            </div>
          </div>
          <div class="cbw-anonymous-save-row">
            <calenso-button
              type="primary"
              text="{{ 'common.save' | translate }}"
              [disabled]="tempCountSafe > getMaxAnonymousAllowed()"
              [widgetColorConf]="widgetColorConf"
              (clickEvent)="saveAnonymousCount()"
            />
          </div>
        </div>
      </div>
    </div>
  }

} @else {
  <!-- Per-guest edit form (only reachable from the named section) -->
  <form #additionalGuestForm="ngForm">
    <div class="cbw-guest-form-panel mt-3">
      <div class="cbw-guest-form-header">
        <div class="cbw-guest-badge">
          <calio-mat-icon iconType="person_filled" height="28px" width="28px" fill="var(--primary-color)" />
        </div>
        <div class="cbw-guest-form-title">
          {{ (tempAdditionalGuestIndex != null ? 'common.editParticipantTitle' : 'common.newParticipantTitle') | translate }}
        </div>
      </div>
      <div class="row cb-event-additional-guest-layout">
      <div class="col-12 col-md-6 col-xl-3 custom-field form-group summary-padding cbw-event-additional-guest-firstname">
        <label class="input-label" for="guestFirstName" id="label_guestFirstName">
          {{ 'customer.prename.label' | translate | addRequired}}
        </label>
        <input
          maxlength="100"
          autocomplete="name"
          [(ngModel)]="tempAdditionalGuests.prename"
          placeholder="{{ 'customer.prename.placeholder' | translate }}"
          name="guestFirstName"
          id="guestFirstName"
          type="text"
          class="form-control cbw-input-field"
          required
          #firstName="ngModel"
          [disabled]="disableAdditionalParticipantsEditing"
          attr.aria-disabled="{{ disableAdditionalParticipantsEditing }}"
          aria-labelledby="label_guestFirstName"
        />
        <ng-container *ngTemplateOutlet="errorHandler; context: { control: firstName, message: 'customer.prename.error' }"/>
      </div>

      <div class="col-12 col-md-6 col-xl-3 custom-field form-group summary-padding cbw-event-additional-guest-lastname">
        <label class="input-label" for="guestLastName" id="label_guestLastName">{{ 'customer.lastname.label' | translate | addRequired}}</label>
        <input
          id="guestLastName"
          name="guestLastName"
          maxlength="100"
          autocomplete="name"
          [(ngModel)]="tempAdditionalGuests.lastname"
          placeholder="{{ 'customer.lastname.placeholder' | translate }}"
          type="text"
          class="form-control cbw-input-field"
          required
          #lastName="ngModel"
          [disabled]="disableAdditionalParticipantsEditing"
          attr.aria-disabled="{{ disableAdditionalParticipantsEditing }}"
          aria-labelledby="label_guestLastName"
        />
        <ng-container *ngTemplateOutlet="errorHandler; context: { control: lastName, message: 'customer.lastname.error' }"/>
      </div>

      <div class="col-12 col-md-6 col-xl-3 custom-field form-group summary-padding cbw-event-additional-guest-email">
        <label class="input-label" for="guestEmail" id="label_guestEmail">{{ 'customer.eMail.label' | translate | addRequired: { isRequired: eventState?.is_widget_event_guest_email_required } }}</label>
        <input
          id="guestEmail"
          name="guestEmail"
          autocomplete="email"
          [(ngModel)]="tempAdditionalGuests.email"
          required="{{ !!eventState?.is_widget_event_guest_email_required }}"
          [placeholder]="((widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_EMAIL_PLACEHOLDER, type: 'template' }) | translation: templateContent.TEMPLATE_CONTENT: lang )"
          type="email"
          email
          #internaleMail="ngModel"
          class="form-control cbw-input-field"
          [disabled]="disableAdditionalParticipantsEditing"
          attr.aria-disabled="{{ disableAdditionalParticipantsEditing }}"
          aria-labelledby="label_guestEmail"
        />
        <ng-container *ngTemplateOutlet="errorHandler; context: { control: internaleMail, message: 'customer.eMail.error' }"/>
      </div>

      <div class="col-12 col-md-6 col-xl-3 custom-field form-group summary-padding cbw-event-additional-guest-phone">
        <label class="input-label" for="guestphone" id="label_guestphone">{{ 'customer.phone.label' | translate | addRequired: { isRequired: eventState?.is_widget_event_guest_phone_required } }}</label>
        <app-cw-intl-tel-input
          [(ngModel)]="tempAdditionalGuests.phone"
          required="{{ !!eventState?.is_widget_event_guest_phone_required }}"
          name="phoneNumber"
          id="phoneNumber"
          #phoneNumber="ngModel"
          cssClass="{{phoneNumber.touched && phoneNumber.invalid ? 'guest-form-tel-input' : ''}}"
          [defaultCountry]="partner?.countryCode"
          autocomplete="tel"
          attr.aria-invalid="{{ phoneNumber.touched && phoneNumber.invalid }}"
          aria-describedby="phoneNumber-hint"
          aria-labelledby="label_phoneNumber"
        />
        <ng-container *ngTemplateOutlet="errorHandler; context: { control: phoneNumber, message: 'customer.phone.error' }"/>
      </div>

      <div class="col-12 cbw-guest-form-footer">
        <div class="d-flex justify-content-end gap-2">
          <calenso-button
            type="secondary"
            text="{{ 'common.cancel' | translate }}"
            customCss="cbw-add-additional-guest-button"
            id="cbw-add-additional-guest-button"
            [widgetColorConf]="widgetColorConf"
            (clickEvent)="cancel();"
          />
          <calenso-button
            type="primary"
            text="{{ 'common.save' | translate }}"
            customCss="cbw-cancel-additional-guest-button"
            id="cbw-cancel-additional-guest-button"
            [widgetColorConf]="widgetColorConf"
            (clickEvent)="save()"
          />
        </div>
      </div>
      </div>
    </div>
  </form>
}

<ng-template #errorHandler let-control="control" let-message="message">
  @if (control.touched && control.invalid) {
    <div role="alert" class="alert alert-danger summary-warning">
      @if (control.errors?.required) {
        {{ message + '.required' | translate }}
      }
      @if (control.errors?.invalidNumber) {
        {{ message + '.invalid' | translate }}
      }
      @if (control.errors?.minlength) {
        {{ message + '.minChars' | translate: control.errors?.minlength }}
      }
      @if (control.errors?.pattern) {
        {{ message + '.pattern' | translate }}
      }
      @if (control.errors?.email) {
        {{ message + '.pattern' | translate }}
      }
    </div>
  }
</ng-template>
